var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentExpenseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IB2cksfwAAAWhQTFRFj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5Wyj5WyAE0COwAAAHh0Uk5TABSo8XhG7dIuChBR/nzssJPZiQYNbsrP3v8w/PBguOrGE1bzXEDDrFXvaJSrN/TE05XO7myNmaACQn4mDnZhgK8o0Oe+UHA/yebV9gfiJxHAI30WGFk74fmxIVhH8t0qV606QwRdcscaTtQMlqe0hoV3Aby16MsxqysLDgAAAShJREFUeJxjZAACRiD4wwABrED2D5AYAwMnI4YE51sGRhFGRiwST2QZlYCMFzyMnExQCcbvjJz/mIGC2oxXGHSB9AWohCGQfYbBlJHRjPEkgwWQcxQqYcPIePo7g/13RjMuRgZM8Iqb0eyCDRYJxs+MZnzYdOw1AdsBBFzCmlC1O0EkyA6whLAp48+rIBFjRsYtyBLubIyMu0ES5jc+fkOWUNLbEMj4luGfGONRVInQ3xvC3gkDvfMLTSL664aYVeF7XBm/okkkfNgQ8kn6Et93GUyJpIv3guYyhGBKpDCuDFyITYKBIY1xJnYJhowZGBKZEO8xMDB/DpgKkchhnAxkKPr+hAYfx0QQWXCMsXBBFEiJzz6oREYfkEjhP8QYqLyfHyPUgUEJACRmgNxtPzq3AAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentExpenseIcon);
export default __webpack_public_path__ + "static/media/student-expense-icon.68d1b99dba59575116d0331aa61d8fb0.svg";
export { ForwardRef as ReactComponent };